module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TH-572d86b73f31c2e2380f1f72f5b1eb36.png";